__turbopack_context__.v({
  "shimmer": "ShimmerLoader-module-scss-module__p0st6G__shimmer",
  "shimmer-loader": "ShimmerLoader-module-scss-module__p0st6G__shimmer-loader",
  "shimmer-loader-wrapper": "ShimmerLoader-module-scss-module__p0st6G__shimmer-loader-wrapper",
});
